import { GET_FAVORITES, GET_FAVORITES_ERROR, GET_FAVORITES_SUCCESS } from "core-web/state/models/User/constants";

import GetFavorites from "core-web/libs/GrebbCommerceAPI/User/GetFavorites";
import store from "core-web/state/store";

export const getFavorites = () => async (dispatch) => {
    dispatch({ type: GET_FAVORITES });

    try {
        const response = await GetFavorites();

        if (await response.ok()) {
            const responseBody = await response.body();
            const products = responseBody.data.items || [];

            dispatch({
                type: GET_FAVORITES_SUCCESS,
                products,
            });

            return products;
        }
    } catch (error) {
        dispatch({ type: GET_FAVORITES_ERROR });

        throw error;
    }
};

export default () => store.dispatch(getFavorites());
